import React from "react";
import styled from "@emotion/styled";
import DateGrid from "./DateGrid";
import Header from "./Header";

function CalendarMonth({ monthName, startOfMonthOffset, schedule }) {
  return (
    <Container>
      <HeaderWrapper>
        <Header monthName={monthName} />
      </HeaderWrapper>
      <DateGridWrapper>
        <DateGrid
          schedule={schedule}
          startOfMonthOffset={startOfMonthOffset}
        />
      </DateGridWrapper>
    </Container>
  );
}

export default CalendarMonth;

const Container = styled.div`
  padding-top: 1.5em;
  background-color: white;
  display: grid;
  grid-template-areas:
    "header"
    "date-grid";
  grid-template-rows: 80px auto;
`;

const HeaderWrapper = styled.div`
  grid-area: header;
`;

const DateGridWrapper = styled.div`
  grid-area: date-grid;
`;
